<script lang="ts">
import { defineComponent, ref, onMounted, PropType } from 'vue'
import Sortable from 'sortablejs'

import TimeSlotItem from './TimeSlotItem.vue'

import { formatTime, localTime } from '../util'
import { TimeSlot, Store } from '../types'

export default defineComponent({
  name: 'TimeSlotList',
  components: {
    TimeSlotItem,
  },
  props: {
    timezone: {
      type: String,
      default: '',
    },
    emitter: {
      type: Object,
      required: true,
    },
    times: {
      type: Array as PropType<TimeSlot[]>,
      required: true,
    },
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
  },
  setup(props) {
    const sortableElements = []
    const timeSlots = ref(props.times)

    onMounted(() => {
      timeSlots.value.forEach(slot => {
        const slotId = 'slot-' + slot.id
        const el = document.getElementById(slotId)

        if (el) {
          sortableElements.push(
            Sortable.create(el, {
              group: { name: 'timeslots', put: true, pull: false },
              sort: false,
              ghostClass: 'bg-gray-100',
              chosenClass: 'bg-orange-500 w-full max-w-xl',
              onUpdate: function(evt) {
                console.log('Updated: ', evt)
              },
              onAdd: function(evt) {
                // console.log('to', evt.to)
                // console.log('to dataset', evt.to.dataset)

                // console.log('event added. id', this.el.id)
                // console.log('event added. options', this.options)
                // console.log('event added. option', this.option)

                props.emitter.emit('assign-artist', {
                  artistId: evt.item.dataset.artistId,
                  slotId: slot.id,
                })
              },
            }),
          )
          // console.log('Created sortable ', slotId)
        } else {
          console.log('FAIL: no HTML element for sortable ', slotId)
        }
      })
    })

    return {
      formatTime,
      localTime,
      props,
    }
  },
})
</script>

<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-md">
    <ul id="slots">
      <li
        v-for="(slot, index) in props.times"
        :key="slot.id"
        class="focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
        :class="{
          'border-t border-gray-200': index !== 0,
          'bg-white': slot.artistId !== null && props.store.selectedSlotId !== slot.id,
          'bg-white border-slipmat-400':
            slot.artistId !== null && props.store.selectedSlotId === slot.id,
        }"
        :data-slot-id:="slot.id"
      >
        <time-slot-item
          :item="slot"
          :timezone="props.timezone"
          :emitter="props.emitter"
          :store="props.store"
          :selected="props.store.selectedSlotId === slot.id"
        ></time-slot-item>
      </li>
    </ul>
  </div>
</template>
